import {isNoElementOnScreen} from "../common/isUnderElement";

let $fixedPanel = $('.fixed-panel');
let $btn = $('#productMainActionButton');

$(window).on('scroll load resize', function () {
    if ($fixedPanel.length) {
        let needShowFixedPanel = isNoElementOnScreen($btn) && !$('header .header-actions').hasClass('search-focused');

        if (needShowFixedPanel) {
            $('.fixed-panel').addClass('show');
        } else {
            $('.fixed-panel').removeClass('show');
        }
    }
});